<div class="dasa-auth">
  <!-- Floating theme toggle so users can switch before signing in -->
  <button type="button"
          class="dasa-auth__theme-toggle"
          (click)="toggleTheme()"
          [title]="themeMode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
          aria-label="Toggle theme">
    <i class="fa-solid" [class.fa-sun]="themeMode === 'dark'" [class.fa-moon]="themeMode === 'light'"></i>
  </button>

  <!-- Left brand panel -->
  <aside class="dasa-auth__brand-panel" aria-hidden="true">
    <div class="dasa-auth__brand-bg"></div>
    <div class="dasa-auth__brand-inner">
      <div class="dasa-auth__brand-logo">
        <img [src]="imageUrl" alt="DASA TECH" />
      </div>
      <h1 class="dasa-auth__brand-heading">
        The Best Till System,<br />
        <span class="dasa-auth__brand-heading--accent">Ever.</span>
      </h1>
      <p class="dasa-auth__brand-tagline">
        Powerful POS, online ordering, bookings and analytics —
        engineered for hospitality operators that move fast.
      </p>

      <ul class="dasa-auth__brand-features">
        <li><i class="fa-solid fa-bolt"></i> Real-time order routing</li>
        <li><i class="fa-solid fa-chart-line"></i> Built-in analytics</li>
        <li><i class="fa-solid fa-mobile-screen"></i> Works on any device</li>
      </ul>
    </div>
  </aside>

  <!-- Right form panel -->
  <section class="dasa-auth__form-panel">
    <div class="dasa-auth__form-card">
      <div class="dasa-auth__form-header">
        <img [src]="imageUrl" alt="DASA TECH" class="dasa-auth__mobile-logo" />
        <h2 class="dasa-auth__form-title" i18n="@@login.component.signIn">
          {{ 'LOGIN.signIn' | translate }}
        </h2>
        <p class="dasa-auth__form-subtitle">
          Welcome back. Sign in to your DASA TECH dashboard.
        </p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="dasa-auth__form" novalidate>
        <div class="form-group">
          <label for="exampleInputEmail1" class="form-label" i18n="@@login.component.email">
            {{ 'LOGIN.email' | translate }}
          </label>
          <input type="email" formControlName="loginemail"
            [(ngModel)]="requestObject.user.email"
            placeholder="you@business.com"
            class="form-control"
            id="exampleInputEmail1"
            autocomplete="username"
            [ngClass]="{ 'is-invalid': submitted && f.loginemail.errors }">
          <div *ngIf="submitted && f.loginemail.errors" class="invalid-feedback">
            <div *ngIf="f.loginemail.errors.required" i18n="@@login.component.email.required">
              {{ 'LOGIN.email.required' | translate }}
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="exampleInputPassword1" class="form-label" i18n="@@login.component.password">
            {{ 'LOGIN.password' | translate }}
          </label>
          <div class="dasa-auth__password">
            <input [type]="password"
              placeholder="Enter your password"
              class="form-control"
              [(ngModel)]="requestObject.user.password"
              formControlName="loginpassword"
              id="exampleInputPassword1"
              autocomplete="current-password"
              [ngClass]="{ 'is-invalid': submitted && f.loginpassword.errors }" />
            <button type="button" class="dasa-auth__password-toggle" (click)="showHidePass()" tabindex="-1"
                    [attr.aria-label]="showIcon ? 'Hide password' : 'Show password'">
              <i class="fa-solid" [class.fa-eye]="!showIcon" [class.fa-eye-slash]="showIcon"></i>
            </button>
            <div *ngIf="submitted && f.loginpassword.errors" class="invalid-feedback">
              <div *ngIf="f.loginpassword.errors.required" i18n="@@login.component.password.required.error">
                {{ 'LOGIN.password.required' | translate }}
              </div>
              <div *ngIf="f.loginpassword.errors.minlength" i18n="@@login.component.password.minlength.error">
                {{ 'LOGIN.password.minlength' | translate }}
              </div>
            </div>
          </div>
        </div>

        <div class="dasa-auth__row">
          <a routerLink="/forget-password" class="dasa-auth__link" i18n="@@login.component.forgotPassword">
            {{ 'Forgot Password' | translate }}
          </a>
        </div>

        <button type="submit" class="btn btn-accent dasa-auth__submit" i18n="@@login.component.login">
          {{ 'login' | translate }}
        </button>

        <p class="dasa-auth__footnote">
          By signing in you agree to the DASA TECH terms of service and privacy policy.
        </p>
      </form>
    </div>
  </section>
</div>
